export default {
  SET_GLOBALS: '@WS/GLOBALS/SET_GLOBALS',
  SET_GLOBAL_HTML: '@WS/GLOBALS/SET_GLOBAL_HTML',
  SET_GLOBAL_HTML_AND_AFFECT_HISTORY: '@WS/GLOBALS/SET_GLOBAL_HTML_AND_AFFECT_HISTORY',
  DETACH_GLOBAL: '@WS/GLOBALS/DETACH_GLOBAL',
  RESET_GLOBAL: '@WS/GLOBALS/RESET_GLOBAL',
};
